module.exports = __webpack_public_path__ + "img/1146342975.fad8ea97.jpg";